// PublicRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PublicRoute = ({ children, token, initialized }) => {
  const location = useLocation(); // Get current location

  if (!initialized) {
    return <div>Loading...</div>;
  }

  // Allow access to /cart even if token exists
  if (token && location.pathname !== "/cart") {
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken.role === "staff" || decodedToken.role === "admin") {
        return <Navigate to="/staff" />;
      } else if (decodedToken.role === "massage_therapist") {
        return <Navigate to="/therapist" />;
      } else if (decodedToken.role === "luminary") {
        return <Navigate to="/luminary" />;
      } else if (decodedToken.role === "blogger") {
        return <Navigate to="/blogger" />;
      }
      return <Navigate to="/member" />;
    } catch (error) {
      console.error("Failed to decode token in PublicRoute:", error);
    }
  }

  return children;
};

export default PublicRoute;
